import { render, staticRenderFns } from "./TestCase.vue?vue&type=template&id=21dd6786&scoped=true"
import script from "./TestCase.vue?vue&type=script&lang=js"
export * from "./TestCase.vue?vue&type=script&lang=js"
import style0 from "./TestCase.vue?vue&type=style&index=0&id=21dd6786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd6786",
  null
  
)

export default component.exports